import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsHikeNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M15.628 6.064A5.5 5.5 0 0119.923 4H22a1.5 1.5 0 011.446 1.101l1.629 5.904a14.5 14.5 0 009.905 10.06l7.627 2.233A7.5 7.5 0 0148 30.496v.64c0 .701-.095 1.5-.442 2.279C46.478 35.838 42.724 42 33 42h-5c-.152 0-.303-.023-.447-.068l-7.022-2.195-1.36 1.7A1.5 1.5 0 0118 42H7.5C3.354 42 0 38.628 0 34.49c0-1.988.79-3.9 2.197-5.308l.367-.367 1.567-14.89A5.5 5.5 0 019.601 9h3.678zM19.923 7a2.5 2.5 0 00-1.953.938L14.72 12H9.602a2.5 2.5 0 00-2.486 2.238L5.666 28c4.606.019 7.02.806 8.975 1.614.238.098.462.193.679.285C16.814 30.534 17.912 31 20 31h15c.872 0 1.396-.264 1.817-.638.493-.436.882-1.047 1.406-1.898l.044-.072c.47-.764 1.07-1.74 1.925-2.499.05-.045.102-.088.154-.131l-6.21-1.818a17.506 17.506 0 01-1.46-.498l-4.61 4.61-2.125-2.118 3.906-3.906a17.507 17.507 0 01-2.248-1.652L23.994 24l-2.125-2.118 3.638-3.653a17.494 17.494 0 01-1.674-2.44L19.8 19.82l-2.125-2.117 4.838-4.838c-.121-.35-.231-.704-.33-1.063L20.858 7zM4.317 31.303A4.509 4.509 0 007.5 39h9.78l2.189-2.737L28.229 39H33c8.096 0 11.009-4.992 11.818-6.807.12-.268.182-.612.182-1.057v-.64a4.496 4.496 0 00-1.14-2.994c-.789.027-1.279.283-1.678.636-.492.436-.88 1.047-1.405 1.898l-.044.072c-.47.764-1.07 1.74-1.925 2.499C37.853 33.452 36.627 34 35 34H20c-2.722 0-4.333-.688-5.875-1.347-.21-.09-.42-.18-.63-.267C11.845 31.704 9.785 31 5.5 31h-.879z"
        fill=""
      />
    </svg>
  )
);
SvgSportsHikeNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsHikeNormalLarge;
